


















import VirtualTable from "@/components/table/VirtualTable.vue";
import FileSearchTableRow from "./FileSearchTableRow.vue";
import { table_config } from "./table.config";
import Vue from "vue";
import { state } from "../data/state";
export default Vue.extend({
  components: { VirtualTable },
  setup() {
    const {
      search: { query, results, loadMore, isLoading, noResults },
    } = state;
    return {
      table_config,
      FileSearchTableRow,
      query,
      results,
      isLoading,
      loadMore,
      noResults,
    };
  },
});
